var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolTransportesAreosLogowine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-167.61 -113.45025 1452.62 680.7015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M657.6.1c-14.1 0-28.1 1.3-41.9 3.9 105.2 19.7 184.9 104 184.9 214.9 0 79-64 151-143 151s-143-64-143.1-142.9c0-62.9 41-118.4 101.2-136.8-13.6-4.1-27.7-6.2-41.9-6.2-79 0-143 72-143 151 0 110.9 79.7 195.3 184.9 214.9 13.8 2.6 27.9 3.9 42 3.9 97.1 0 180-61 212.3-146.9V147C837.5 61.2 754.7.1 657.6.1z",
    opacity: 0.25,
    fill: "#37322d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M615.7 4C601.9 1.4 587.9.1 573.8.1 465 .1 374.1 76.7 352.1 178.9c-.8 3.5-3.8 5.9-7.4 5.9H234.3c-4.2 0-7.6 3.4-7.6 7.5v68.6c0 4.2 3.4 7.6 7.6 7.6h96.9c4.2 0 7.6 3.4 7.6 7.6v34c0 3.6-1.3 7.1-3.7 9.9-51.5 59.8-141.7 66.6-201.6 15.1-59.9-51.5-66.6-141.7-15.1-201.6 42.2-49 111.9-63.6 170.2-35.6 3.5 1.8 7.8.5 9.9-2.9l35.2-59.2c2.1-3.6 1-8.2-2.6-10.4-.1-.1-.2-.1-.4-.2C298.6 8.6 262.9-.1 226.7 0 101.5.1 0 101.7 0 226.9s101.5 226.8 226.8 226.8c64 .1 124.9-26.9 167.9-74.3 2.8-3.1 7.6-3.3 10.7-.5.2.2.4.3.5.5 53 58.3 132.4 84.9 209.8 70.5-105.2-19.6-184.9-104-184.9-214.9 0-79 64-151 143-151s143 64 143 143c0 62.9-41 118.3-101.1 136.8 13.6 4.2 27.7 6.3 41.9 6.2 79 0 143-72 143-151-.1-111-79.7-195.3-184.9-215zm494.1 359.5H961.1c-4.2 0-7.6-3.4-7.6-7.6V14.2c0-4.2-3.4-7.6-7.5-7.6h-68.6c-4.2 0-7.6 3.4-7.6 7.6v417.9c0 8.4 6.8 15.1 15.1 15.1h224.9c4.2 0 7.6-3.4 7.6-7.6V371c0-4.1-3.4-7.5-7.6-7.5z",
    fill: "#ff7020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolTransportesAreosLogowine);
export default __webpack_public_path__ + "static/media/Gol_Transportes_Aéreos-Logo.wine.cc50e9f4638c77fb8c277d5f7551d294.svg";
export { ForwardRef as ReactComponent };